import { memo } from 'react';
import { addPointsInText } from '../../../../helpers/app';
import { images } from '../../../../constants/images';
import styles from '../../publicationDetail.module.scss';
import { PublicationPriceIndicatorProps } from '../../interfaces';

const PublicationPriceIndicator = ({
  hasValidSuggestedPrices,
  getPriceCategory,
  getIndicatorPosition,
  getPriceDifferenceMessage,
  publication
}: PublicationPriceIndicatorProps) => {
  if (!hasValidSuggestedPrices) return null;
  
  return (
    <div className={styles.marketPriceSectionPublication}>
      <h3>Precios del mercado</h3>
      <div className={styles.marketPriceInfo}>
        <div className={styles.priceBar}>
          <div className={styles.priceBarInner}>
            {/* Precio + etiqueta arriba del indicador */}
            <div
              className={styles.priceTag}
              style={{ left: `${getIndicatorPosition()}%` }}
            >
              <p className={styles.actualPrice}>${addPointsInText(publication?.price)}</p>
              <div className={styles.priceCategory}>
                <img
                  src={
                    getPriceCategory() === "good"
                      ? images.checkVerde // buena imagen
                      : getPriceCategory() === "fair"
                        ? images.checkAmarillo // imagen regular
                        : images.checkRojo // imagen cara
                  }
                  alt="Indicador de precio"
                  className={styles.priceIcon}
                  style={{ width: '18px', height: '18px' }}
                />
                {getPriceCategory() === "good"
                  ? "Buen precio"
                  : getPriceCategory() === "fair"
                    ? "Precio justo"
                    : "Precio elevado"}
              </div>
            </div>

            {/* Línea + marcador */}
            <div className={styles.pricePointer} style={{ left: `${getIndicatorPosition()}%` }} />
          </div>
        </div>

        <div className={styles.suggestedPriceDisplay}>
          <h3>${addPointsInText(publication?.suggested_prices?.suggested_price || publication?.suggested_prices?.sale)}</h3>
          <p>Precio Sugerido</p>
        </div>

        <p className={styles.priceInfo}>
          {getPriceDifferenceMessage()}
        </p>
      </div>
    </div>
  );
};

export default memo(PublicationPriceIndicator);
